export default __webpack_public_path__ + "static/media/icon_login_outline.c015947c.svg";